export const WIPE_PERIOD_MS = 2800;
export const WIPE_RESUME_MS = 2000;
export const WIPE_KEYBOARD_STEP = 0.05;

export type WipeDirection = 1 | -1;

export function clamp01 (value: number): number {
  if (value <= 0) {
    return 0;
  }
  if (value >= 1) {
    return 1;
  }
  return value;
}

export function stepWipe (
  split: number,
  direction: WipeDirection,
  dtMs: number,
  periodMs = WIPE_PERIOD_MS
): { split: number, direction: WipeDirection } {
  if (periodMs <= 0 || dtMs <= 0) {
    return { split: clamp01(split), direction };
  }
  let next = split + direction * (dtMs / periodMs);
  let nextDirection: WipeDirection = direction;
  if (next >= 1) {
    next = 1;
    nextDirection = -1;
  } else if (next <= 0) {
    next = 0;
    nextDirection = 1;
  }
  return { split: clamp01(next), direction: nextDirection };
}

export function splitFromClientX (
  clientX: number,
  rectLeft: number,
  rectWidth: number
): number {
  if (rectWidth <= 0) {
    return 0;
  }
  return clamp01((clientX - rectLeft) / rectWidth);
}
